module.exports = __webpack_public_path__ + "media/images/icons/credit_card/master-d04e703b0044092255927756306ec034.svg";